import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import JobsListResults from 'src/components/jobs/JobsListResults';
import JobsToolBar from 'src/components/jobs/JobsToolBar';
import { getJobsList, removeJobByID } from 'src/redux/jobs/action';
import { api } from 'src/service';
import { usePersistedPagerInfo } from 'src/utils/usePersistedLimit';

const Jobs = () => {
  const dispatch = useDispatch();
  const [jobs, setJobs] = useState();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [jobID, setJobID] = useState();
  const [searchStr, setSearchStr] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);
  const [pagerInfo, setPagerInfo] = usePersistedPagerInfo('jobs', { limit: 10 });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        await api
          .post('/backoffice/orders/filter', {
            page_size: pagerInfo.limit,
            current_page: pagerInfo.page,
            search: searchStr,
          })
          .then((res) => {
            setJobs(res.data.data.data);
            setPagerInfo({
              limit: res.data.data.page_size,
              page: res.data.data.current_page,
              totalSize: res.data.data.total_size,
            });
          });
      } catch (error) {
        const message = error.response
          ? error.response.data.moreInformation.error
          : { message: error.message };
        throw new Error(message);
      }
      setLoading(false);
    };

    fetchData();
  }, [searchStr, pagerInfo.page, pagerInfo.limit, refreshKey]);

  const handleRefresh = () => {
    setRefreshKey((k) => k + 1);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleRow = async (id) => {
    handleOpen(true);
    setJobID(id);
  };

  const handleRemove = async () => {
    setOpen(false);
    setLoading(true);
    await dispatch(removeJobByID(jobID));
    const data = await dispatch(getJobsList());
    setJobs(data);
    setLoading(false);
  };

  const handleSearchStr = (str) => {
    setSearchStr(str);
  };

  const handlePagerInfo = (info) => {
    setPagerInfo(info);
  };

  return (
    <>
      <Helmet>
        <title>Washer - Washes</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>
          <JobsToolBar
            handleSearchStr={handleSearchStr}
            onRefresh={handleRefresh}
            refreshing={loading}
          />
          <Box sx={{ pt: 3 }}>
            <JobsListResults
              jobs={jobs}
              handleRow={handleRow}
              handlePagerInfo={handlePagerInfo}
              pagerInfo={pagerInfo}
              loading={loading}
              onAssigned={handleRefresh}
            />
          </Box>
          <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle id="responsive-dialog-title">Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to remove it?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={handleClose} color="primary">
                Disagree
              </Button>
              <Button onClick={handleRemove} color="primary" autoFocus>
                Agree
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
    </>
  );
};

export default Jobs;
